import { colors } from '../../app/variables.js'

export const buttonStyle = {
  color: colors.evantaBlue,
  marginBottom: '0px',
  paddingTop: '7px',
  paddingBottom: '7px',
  backgroundColor: colors.lightestGray,
  border: 'none',
  cursor: 'pointer'
}

export const titleStyle = {
  textAlign: 'center',
  marginBottom: '0px',
  paddingTop: '7px',
  paddingBottom: '7px'
}

export const barStyle = {
  backgroundColor: colors.lightestGray,
  borderTop: '2px solid ' + colors.mediumGray,
  marginBottom: '20px'
}
